const img = require('./programming_module_l_action.png'); export default img;